import { render, staticRenderFns } from "./BackofficeCotacaoOperadora.vue?vue&type=template&id=6f889f90&scoped=true"
import script from "./BackofficeCotacaoOperadora.vue?vue&type=script&lang=ts"
export * from "./BackofficeCotacaoOperadora.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeCotacaoOperadora.vue?vue&type=style&index=0&id=6f889f90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f889f90",
  null
  
)

export default component.exports